export interface PasswordResetRequest {
  mail: string;
  newPassword: string;
  resetCode: string;
}

// Enum for password change steps (must match the one in passwordRecoverySlice)
export enum PasswordChangeStep {
  EMAIL_INPUT = 0,
  OTP_INPUT = 1,
  PASSWORD_INPUT = 2,
  SUCCESS = 3
}

export interface PasswordRecoveryState {
  email: string | null;
  isEmailSent: boolean;
  isLoading: boolean;
  error: string | null;
  verificationCode: string;
  passwordChangeStatus: "success" | "failed" | null;
  passwordChangeError: string | null;
  timestamp: number | null;
  currentStep: PasswordChangeStep;
}

export interface SendEmailPayload {
  email: string;
  timestamp: number;
}

export interface PassResetResponse {
  error: boolean;
  message: string;
}

export interface SendCodeRequest {
  mail: string;
}
